import { render, staticRenderFns } from "./addDynamic.vue?vue&type=template&id=1149a2a4&scoped=true&"
import script from "./addDynamic.vue?vue&type=script&lang=js&"
export * from "./addDynamic.vue?vue&type=script&lang=js&"
import style0 from "./addDynamic.vue?vue&type=style&index=0&id=1149a2a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1149a2a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1149a2a4')) {
      api.createRecord('1149a2a4', component.options)
    } else {
      api.reload('1149a2a4', component.options)
    }
    module.hot.accept("./addDynamic.vue?vue&type=template&id=1149a2a4&scoped=true&", function () {
      api.rerender('1149a2a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/version/components/addDynamic.vue"
export default component.exports